// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","dialog":"dialog-2bvFs","dialog_actions":"dialog_actions-2Eh5q","title":"title-3X0Sq","text":"text-2FR4l","closeButton":"closeButton-3mHJV"};